import React, { useState } from "react";
import {
  FaHandsHelping,
  FaCalendarAlt,
  FaBookOpen,
  FaLaptopCode,
} from "react-icons/fa";
import "../../styles/Pillar.css";

const Pillar = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const pillars = [
    {
      number: "01",
      title: "Mentorship",
      icon: <FaHandsHelping />,
      description:
        "Guided by industry leaders, WiSE provides mentorship in three formats to help women navigate challenges, gain clarity, and accelerate their growth in the semiconductor ecosystem. ",
    },
    {
      number: "02",
      title: "Events and Meetups",
      icon: <FaCalendarAlt />,
      description:
        "WiSE hosts diverse online and offline events, including webinars, expert talks, and meetups, designed to foster learning, meaningful connections, and career growth within the semiconductor ecosystem.",
    },
    {
      number: "03",
      title: "Storytelling",
      icon: < FaBookOpen />,
      description:
         "Through blogs, spotlights, and shared experiences, WiSE creates a platform for members and industry leaders to inspire, learn, and build confidence within the semiconductor community.",
    },
    {
      number: "04",
      title: "Training and Projects",
      icon: <FaLaptopCode />,
      description:
        "WiSE offers skill-focused training and hands-on projects that bridge academia and industry, empowering women with practical experience and confidence for real-world success.",
    },
  ];

  return (
    <section className="pillar-section">
      <div className="container">
        <div className="home-cohort-header">
          <h2 className="wise-secondary-gradient cohort-main-title">
            OUR PILLARS
          </h2>
          <p className="text-secondary home-cohort-subtitle">
            A holistic foundation of mentorship, learning, storytelling, and
                hands-on growth—designed to empower women at every stage of
                their semiconductor journey.
          </p>
        </div>

        <div className="pillar-row">
          {pillars.map((item, index) => {
            const isActive = activeIndex === index;

            return (
              <div
                key={index}
                className={`pillar-card ${isActive ? "active" : ""}`}
                onClick={() => setActiveIndex(index)}
              >
                <div className="pillar-number">[{item.number}]</div>

                <div className="pillar-icon">
                    {isActive ? (
                         item.icon
                        ) : (
                              <img src="/assets/images/pillar.svg" alt="pillar" className="pillar-svg"/>
                              )}
                </div>

                {isActive && (
                  <div className="pillar-content">
                    <h3 className="pillar-title">{item.title}</h3>
                    <p className="pillar-description">
                      {item.description}
                    </p>
                  </div>
                )}

                {!isActive && (
                  <div className="pillar-collapsed-title">
                    {item.title}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Pillar;